// extracted by mini-css-extract-plugin
export var paymentSwitcher = "index-module--paymentSwitcher--x40xm";
export var switchButton = "index-module--switchButton--4AfJL";
export var switchButtonActive = "index-module--switchButtonActive--4aEkF";